import type { ReactNode } from 'react';
import { useReducer } from 'react';
import type { IUiState } from './uiStateContext';
import { UiStateContext } from './uiStateContext';
import { uiStateReducer } from './uiStateReducer';

interface IUiStateProviderProps {
    children: ReactNode;
}

export function UiStateProvider(props: IUiStateProviderProps) {
    const initialState: IUiState = {
        bannerHeight: 0,
        isAskEmploymentForSpecializationsModalOpen: false,
        isFeedbackModalOpen: false,
        isSupportModalOpen: false,
        isTopBarOpen: false,
    };
    const [uiState, dispatchUiStateAction] = useReducer(uiStateReducer, initialState);

    const contextValue = { uiState, dispatchUiStateAction };

    return <UiStateContext.Provider value={contextValue}>{props.children}</UiStateContext.Provider>;
}
